import cn from 'classnames';
import React, {FC} from 'react';

import AppLoaderContent from './AppLoaderContent';

interface IProps {
    loaderClassName?: string;
}
const AppLoaderMedia: FC<IProps> = ({loaderClassName}) => (
    <div className={cn('absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]', loaderClassName)}>
        <AppLoaderContent loaderText='' />
    </div>
);

export default AppLoaderMedia;
